import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { useAsyncThrow } from './useAsyncThrow';
import axios from 'axios';
import { jobInfoAtom } from '../recoil/atoms/jobInfoAtom';

const GATEWAY_TIMEOUT_STATUS_CODE = 504;

export function useIssueInsurance(): {
    issueInsurance: () => Promise<void>;
} {
    const { asyncThrow } = useAsyncThrow();
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const issueInsurance = async (): Promise<void> => {
        try {
            await OnlineSales.issue(jobNumber, sessionId);
        } catch (err) {
            if (axios.isAxiosError(err) && err.response?.status !== GATEWAY_TIMEOUT_STATUS_CODE) {
                asyncThrow(err);
            }
        }
    };

    return { issueInsurance };
}
